import { render, staticRenderFns } from "./ComercioExterior.vue?vue&type=template&id=e92d2550"
import script from "./ComercioExterior.vue?vue&type=script&lang=js"
export * from "./ComercioExterior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports